import { getWidthPercents } from '../../utils';

export const Text = (html: string) => (index: number) => `
<mj-column width="${getWidthPercents(index)}" border-radius="5px">
    <mj-text color="#000" padding="8px" font-size="14px" line-height="normal" align="justify">
        ${html}
    </mj-text>
</mj-column>
`;
